import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { Location } from '@angular/common';
import { inject, Injectable, } from '@angular/core';
import { Router, ActivatedRoute, } from '@angular/router';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { Platform } from '@angular/cdk/platform';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Preference } from './preference';
import { idNameItem, JkOpenwinParams, jkRestReturn } from './jkInterface';
import { jkRestReturnClass } from './jkClass';
//import { InputDialogComponent } from '../components/input-dialog/input-dialog.component';
import { Observable } from 'rxjs';
import { login, LoginService } from './jkUser';
import { ConfirmDialogComponent, ConfirmDialogData } from '../components/confirm-dialog/confirm-dialog.component';
import { InputDialogComponent } from '../components/input-dialog/input-dialog.component';



@Injectable({
  providedIn: 'root',
})
export class PageService {
  public preference: Preference = inject(Preference);
  protected activatedRoute: ActivatedRoute = inject(ActivatedRoute);
  public dialog: MatDialog = inject(MatDialog); // ModalController;
  public router: Router = inject(Router);
  public location: Location = inject(Location);
  public sanitizer: DomSanitizer = inject(DomSanitizer);
  public snackBar: MatSnackBar = inject(MatSnackBar);
  public _title: Title = inject(Title);
  public platform: Platform = inject(Platform);
  //private meta: Meta;
  //protected translate: TranslateService;
  //protected sanitizer: DomSanitizer;
  public get isLogin(): boolean {
    if (this.login) return this.login.isLogin;
    else return false;
  }
  public get serverUrl(): string {
    //return environment.serverUrl;
    if (!this.login) return '';
    return this.login.hostName;
  }
  public get uid(): string {
    if (!this.login) return '';
    return this.login.userid;
  }
  public get userName(): string {
    if (!this.login) return '';
    return this.login.name;
  }
  login: LoginService; // =inject(LoginService);

  constructor() {
    this.login = login;
  }
  async doOpenWinClick<T>(com: any, param: JkOpenwinParams, callback: any) {
    let values: any[] = [];
    //let dialog = this.injector.get(MatDialog);
    //const dialogRef = dialog.open(JkopenwinComponent, { data: param }); // ,{width:300,height:300}
    const dialogRef = this.dialog.open<T>(com, this.initConfig_component(param)); // ,{width:300,height:300}

    dialogRef.afterClosed().subscribe((result) => {
      if (result.result) {
        try {
          let items = result.obj.returnData;
          if (items) {
            for (let i = 0; i < items.length; i++) {
              let e = items[i];
              //let value = this.values.find((item)=>item[data.valueExpr]===e[data.valueExpr]);
              let obj: idNameItem = { id: '', name: '' };
              obj.id = e[param.valueExpr];
              obj.name = e[param.displayExpr];
              values.push(obj);
            }
          }
          callback(values);
          //this.ref.detectChanges();
        } catch (error: any) {
          alert('openwin 回傳錯誤:' + error);
        }
      }
    });
  }
  initConfig_component(
    param: any,
    disableClose: boolean = true,
    height: string = '95%',
    width: string = '95%',
    dialogClass: string = 'jk-dialog-resize' //'jk-dialog-resize' 'mat-dialog-container'
  ): MatDialogConfig {
    let dialRet: jkRestReturn = new jkRestReturnClass();
    //if(!dialogClass)
    // dialogClass = 'resize: both;overflow: auto;';
    dialRet.obj = param;
    let dialConf: MatDialogConfig = {
      data: dialRet,
      hasBackdrop: true,
      //maxHeight: '90vh',
      maxWidth: '100vw',
      height: height,
      width: width,
      disableClose: disableClose,
      panelClass: dialogClass, //dialogClass   // 預設就會顯示不出來!
    };
    return dialConf;
  }
  //async showInput( title: string,    label: string,inputValue: string,inputType: 'text'|'email'|'url'|'password'|'textarea' = 'text'  ): Promise<any> {
  showInput(title: string, label: string, inputValue: string, inputType: 'text' | 'email' | 'url' | 'password' | 'textarea' = 'text'): Observable<any> {
    //const dialogRef = this.dialog.open(InputDialogComponent, {

    const dialogRef = this.dialog.open(InputDialogComponent, { // FIXME: 未測試
      width: '250px',
      data: { title, label, inputValue, inputType }
    });

    //const result = await dialogRef.afterClosed().toPromise();
    //return result;
    return dialogRef.afterClosed();

  }
  horizontalPosition: MatSnackBarHorizontalPosition = 'center';
  verticalPosition: MatSnackBarVerticalPosition = 'bottom';
  showAlert(message: string, title: string = '確定') {
    this.snackBar.open(message, title, {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
    });
  }
  async showToast(
    message: string,
    duration: number = 3000,
    position: MatSnackBarVerticalPosition = 'bottom',
    icon: 'success' | 'error' | 'info' | 'warning' = 'success',
    color: 'primary' | 'accent' | 'warn' = 'primary'
  ) {
    this.snackBar.open(message, '', {
      duration: duration,
      verticalPosition: position,
      panelClass: [`mat-snackbar-${icon}`, `mat-snackbar-${color}`]
    });
  }
  async showConfirm(
    title: string,
    text: string
  ): Promise<boolean> {
    let data: ConfirmDialogData = { title: title, content: text, result: false };
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '300px',
      data: data
    });

    return dialogRef.afterClosed().toPromise();

    return new Promise<boolean>((resolve, reject) => {
      resolve(true);
    });
  }
  goBack() {
    //if (this.location){
    if (false) { // FIXME: 暫時改
      console.log('this.location.goBack');
      this.location.back();
    }
    else
      if (this.router)
        this.router.navigate(['/'])
      else
        alert('hi碼農:goback 無法執行!');
  }
  async showMessage(msg: string, action: string = '確定', type: string = 'success') {
    this.snackBar.open(msg, action);
  }


}

